import React, { useEffect, useState } from "react";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import { getQuote } from "../../Components/Quotations/quotesApi";
import { getQuoteIdFromUrl } from "../../Components/Quotations/quoteUtils";
import QuotationDetailView from "../../Components/Quotations/quotationDetails";

const QuotationDetail = ({ translate }) => {
  const [loader, setLoader] = useState(true);
  const [quote, setQuote] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    getQuote(getQuoteIdFromUrl())
      .then((data) => {
        setQuote(data);
        setLoader(false);
        const companyId=data?.attributes?.companyId||data?.companyId
        if (!companyId) return;
        getCompanyById(companyId)
          .then(setCompany)
          .catch(() => {});
      })
      .catch(() => {
        setLoader(false);
        setQuote(null);
      });
  }, []);

  if (loader) return <Loader component="filter" />;

  return (
    <QuotationDetailView
      quote={quote}
      company={company}
      emptyText={translate?.("noRecordFound") || "Quotation not found"}
    />
  );
};

export default QuotationDetail;
